/**
 * @author jaeho.lee104 on 2023. 07. 11..
 */
export class LanguageUtils {
    static isKorean(language: string): boolean {
        return language === "kr"
    }
}